<template>
<div class="chapter">
<div class="inner_page">
<div class="cover">
<img alt="Uncommon Courtesy: The Basics of Good Behavior for a Badly Behaved World, by Jennifer M Wood." height="100%" src="OEBPS/images/cover.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?488ba628